"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SIZE", {
  enumerable: true,
  get: function get() {
    return _modal.SIZE;
  }
});
Object.defineProperty(exports, "ROLE", {
  enumerable: true,
  get: function get() {
    return _modal.ROLE;
  }
});
exports.Modal = void 0;

var _react = _interopRequireDefault(require("react"));

var _modal = require("baseui/modal");

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// https://baseweb.design/components/modal/
var Modal = function Modal(_ref) {
  var animate = _ref.animate,
      closeable = _ref.closeable,
      children = _ref.children,
      header = _ref.header,
      footer = _ref.footer,
      rest = _objectWithoutProperties(_ref, ["animate", "closeable", "children", "header", "footer"]);

  return _react["default"].createElement(_modal.Modal, _extends({
    animate: true,
    closeable: true
  }, rest), header && _react["default"].createElement(_modal.FocusOnce, null, _react["default"].createElement(_modal.ModalHeader, null, header)), _react["default"].createElement(_modal.ModalBody, null, children), footer && _react["default"].createElement(_modal.ModalFooter, null, footer));
};

exports.Modal = Modal;
Modal.propTypes = {
  animate: _propTypes.bool,
  closeable: _propTypes.bool,
  children: (0, _propTypes.oneOfType)([_propTypes.node, (0, _propTypes.arrayOf)(_propTypes.node)]).isRequired,
  footer: (0, _propTypes.oneOfType)([_propTypes.node, (0, _propTypes.arrayOf)(_propTypes.node)]),
  header: (0, _propTypes.oneOfType)([_propTypes.node, (0, _propTypes.arrayOf)(_propTypes.node)])
};
Modal.defaultProps = {
  animate: true,
  closeable: true,
  footer: undefined,
  header: undefined
};